import { inject, Injectable } from '@angular/core'

import { LogTransport } from './log-transport'
import { LOG_TRANSPORTS } from './log-transports.token'
import { Logger } from './logger'
import { stringToColor } from './logger-helper'

@Injectable()
export class LoggerService {
  private loggers = new Map<string, number>()
  private readonly logTransports: LogTransport[] = inject(LOG_TRANSPORTS)
  constructor() {
    if (ngDevMode && !Array.isArray(this.logTransports)) {
      throw new Error('LOG_TRANSPORTS needs to be provided with multi:true')
    }
  }

  getInstance(name: string, hexColor?: string): Logger {
    hexColor = hexColor || stringToColor(name)

    const loggerCount = this.loggers.get(name)
    if (loggerCount) {
      // add postfix with count
      const count = loggerCount + 1
      this.loggers.set(name, count)
      name += `_${count}`
    } else {
      this.loggers.set(name, 1)
    }

    return new Logger(name, hexColor, this.logTransports)
  }
}
